var styles = {"quickActionLink":"styles_quick-action-link__Uo-F-","children":"styles_children__o0gWz"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
